import React from 'react'

const Input = (props) => <input {...props} />

export default Input
